// web_components/wcAgeGateModal/wcAgeGateModal_Renderer.ts

/**
 * Generates the HTML for the wc-age-gate-modal component.
 * Handles CSS, variables, etc.
 *
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(instanceId: string): string {
	return `
        <style>
            .sr-only {
                /** Where would this be used? When we know, use %sr-only placeholder in the SCSS instead **/
                position: absolute;
                width: 1px;
                height: 1px;
                padding: 0;
                margin: -1px;
                overflow: hidden;
                clip: rect(0, 0, 0, 0);
                border: 0;
            }
        </style>
        
        <div id="${instanceId}" class="wc-age-gate-modal modal-active modal-transition" role="dialog" aria-labelledby="ageGateModalTitle" aria-describedby="ageGateModalDescription" aria-modal="true" tabindex="-1">
        	<div class="wc-modal__overlay"><i></i></div>
            <div class="wc-modal__dialog">
                <img src="${window.serverData.contextPath + '/skin/images/logos/VW_Logo_2023_Inline.png'}" alt="Logo">
                <h2 id="ageGateModalTitle">${window.serverData?.ageGateModalHeading}</h2>
                <p id="ageGateModalDescription" class="wc-age-gate-modal__description">
                    ${window.serverData?.ageGateModalCopy}
                </p>
                <button id="wc-age-gate-modal__continue-btn" aria-label="Close modal">${window.serverData?.ageGateModalButtonCopy}</button>
            </div>
        </div>
    `;
}
